import React from "react"
import "./work_entry.scss"

import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Card from "react-bootstrap/Card"
import ShowMore from "../components/show_more"

export default function WorkEntry(props) {
  return (
    <Card className="work-entry">
      <Container>
        <Row>
          <Col sm={12} md={5}>
            <div className="details">
              <div className="date">{props.date}</div>
              <div className="company">{props.company}</div>
              <div className="position">{props.position}</div>
              <div className="location">{props.location}</div>
            </div>
          </Col>
          <Col sm={12} md={7}>
            <div className="description">{props.description}</div>
          </Col>
        </Row>
        {props.ShowMore && (
          <Row>
            <ShowMore>{props.ShowMore}</ShowMore>
          </Row>
        )}
      </Container>
    </Card>
  )
}
